export default __webpack_public_path__ + "static/media/caret-active.0258d21b.svg";